export * from '@reversible/schema';

// 性别
export enum UserRole {
  Test = 0,
  Annotator = 1,
  Admin = 2,
}

// type of labeling
export enum LabelType {
  Classify = 'classify',
  Verify = 'verify',
}

export const availableLabelTypes = (userRole: UserRole) =>
  userRole === UserRole.Annotator ? [LabelType.Classify] : [LabelType.Classify, LabelType.Verify];
